// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group.keyword[data-v-497c06be]{position:relative}.clear-keyword[data-v-497c06be]{position:absolute;top:2px;right:35px;z-index:9}", ""]);
// Exports
module.exports = exports;
